
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system/examples/unclaimed-weekly-draw-prize",
      function () {
        return require("private-next-pages/design-system/examples/unclaimed-weekly-draw-prize.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system/examples/unclaimed-weekly-draw-prize"])
      });
    }
  